var map = {
	"./arrow_back-24px.svg": "31e5",
	"./article-24px.svg": "f76a",
	"./call-24px.svg": "6940",
	"./category-24px.svg": "f4d1",
	"./chat-24px.svg": "6a9e",
	"./download-24px.svg": "c2e7",
	"./email-24px.svg": "2a3b",
	"./layers-24px.svg": "4252",
	"./menu-24px.svg": "4ac0",
	"./place-24px.svg": "a0e9",
	"./print-24px.svg": "e304",
	"./search-24px.svg": "70e6",
	"./support_agent-24px.svg": "b7fb",
	"./widgets-24px.svg": "d836"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8efd";